// frontend/admin-portal/src/components/settings/items/NumberInput.jsx
import React from "react";
import { Input } from "@fiberhome/shared-ui";

export default function NumberInput({
  value,
  onChange,
  min,
  max,
  step = 1,
  disabled = false,
}) {
  const handle = (e) => {
    if (typeof onChange !== "function") return;
    const n = Number(e.target.value);
    onChange(Number.isNaN(n) ? 0 : n);
  };
  return (
    <Input
      type="number"
      value={value ?? 0}
      onChange={handle}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      readOnly={typeof onChange !== "function"}
    />
  );
}
